export class KeyValuePair {
  public id: string;
  public displayName: string;

}
